// extracted by mini-css-extract-plugin
module.exports = {"module":"CutoffList_module__2pN4f"};